var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"multiple":_vm.multiple,"size":_vm.size,"placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.dicCode,attrs:{"label":item.dicName,"value":item.dicCode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }